import { render, staticRenderFns } from "./EcocolordopplerArtiSuperioriViewComponent.vue?vue&type=template&id=6388d9e0"
import script from "./EcocolordopplerArtiSuperioriViewComponent.vue?vue&type=script&lang=js"
export * from "./EcocolordopplerArtiSuperioriViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports